import Http from '../http'

// 服务器模块API
export default {
  // 全部服务器信息
  getAllServerInfo () {
    return Http.post('/sys/allserver.do')
  },
  // 获取登录服务器
  getLoginServer () {
    return Http.post('/sys/loginserver.do')
  },
  // 保存登录服务器
  saveLoginServer (params) {
    return Http.post('/sys/save.do', params)
  },
  // 获取服务器列表
  getServerList (params) {
    return Http.post('/sys/server.do', params)
  },
  // 新增服务器
  addServer (params) {
    return Http.post('/sys/add.do', params)
  },
  // 获取单个服务器信息(编辑)
  getSingleServer (params) {
    return Http.post('/sys/get.do', params)
  },
  // 删除服务器
  deleteServer (params) {
    return Http.post('/sys/delete.do', params)
  },
  // 保存服务器
  saveServer (params) {
    return Http.post('/sys/save.do', params)
  },
  // 获取下载站点列表
  getStationList (params) {
    return Http.post('/sys/station.do', params)
  },
  // 新增下载站点
  addStation (params) {
    return Http.post('/sys/addStation.do', params)
  },
  // 获取单个下载站点信息(编辑)
  getSingleStation (params) {
    return Http.post('/sys/getStation.do', params)
  },
  // 删除下载站点
  deleteStation (params) {
    return Http.post('/sys/deleteStation.do', params)
  },
  // 保存下载站点
  saveStation (params) {
    return Http.post('/sys/updateStation.do', params)
  },
  // 系统用户日志
  systemUserLog (params) {
    return Http.post('/sys/sysLog.do', params)
  },
  // 用户日志
  userLog (params) {
    return Http.post('/sys/userLog.do', params)
  },
  // 服务器日志
  serverLog (params) {
    return Http.post('/sys/serverLog.do', params)
  },
  // 获取储存服务器未关联的车辆信息
  getStoreServerFreeDev (params) {
    return Http.post('/sys/storeRelFree.do', params)
  },
  // 获取储存服务器的关联车辆信息
  getStoreServerRelDev (params) {
    return Http.post('/sys/storeRelList.do', params)
  },
  // 存储服务器-终端关联--添加
  addStoreFreeDevToRel (params) {
    return Http.post('/sys/storeRelAdd.do', params)
  },
  // 删除储存服务器关联的设备
  deleteStoreRelDev (params) {
    return Http.post('/sys/storeRelDel.do', params)
  },
  // 获取下载服务器未关联的车辆信息
  getDownServerFreeDev (params) {
    return Http.post('/sys/wifiDownRelFree.do', params)
  },
  // 获取下载服务器的关联车辆信息
  getDownServerRelDev (params) {
    return Http.post('/sys/wifiDownRelList.do', params)
  },
  // 下载服务器-终端关联--添加
  addDownFreeDevToRel (params) {
    return Http.post('/sys/wifiDownRelAdd.do', params)
  },
  // 删除下载服务器关联的设备
  deleteDownRelDev (params) {
    return Http.post('/sys/wifiDownRelDel.do', params)
  },
  // 平台运行监控管理
  getPlatformOperationMonitor (params) {
    return Http.post('/monitor/list.do', params)
  },
  // 地址服务器设置list
  getMapkey (params) {
    return Http.post('/mapkey/list.do', params)
  },
  // 地址服务器设置add
  getMapkeyAdd (params) {
    return Http.post('/mapkey/add.do', params)
  },
  // 地址服务器设置delete
  getMapkeyDelete (params) {
    return Http.post('/mapkey/delete.do', params)
  },
  // 地址服务器设置GET
  getSingleMapkey (params) {
    return Http.post('/mapkey/get.do', params)
  },
  // 地址服务器设置save
  getMapkeySave (params) {
    return Http.post('/mapkey/save.do', params)
  },
  // SNMP
  getSnmpList (params) {
    return Http.post('/snmp/list.do', params)
  },
  // 获取ftp列表
  getFTPList (params) {
    return Http.post('/ftpUser/list.do', params)
  },
  // 获取FTP未关联的车辆信息
  getFTPFreeDev (params) {
    return Http.post('/ftpUser/ftpDevRelFree.do', params)
  },
  // 获取FTP的关联车辆信息
  getFTPRelDev (params) {
    return Http.post('/ftpUser/ftpUserRelList.do', params)
  },
  // FTP-终端关联--添加
  addFTPFreeDevToRel (params) {
    return Http.post('/ftpUser/ftpUserRelAdd.do', params)
  },
  // 删除FTP关联的设备
  deleteFTPUserRelDev (params) {
    return Http.post('/ftpUser/ftpDevRelDel.do', params)
  },
  // 新增FTP
  addFTPUser (params) {
    return Http.post('/ftpUser/add.do', params)
  },
  // 保存FTP
  saveFTPUser (params) {
    return Http.post('/ftpUser/save.do', params)
  },
  // 删除FTP
  deleteFTPUser(params) {
    return Http.post('/ftpUser/delete.do', params)
  },
  // 获取单个FTP信息(编辑)
  getFtpUser (params) {
    return Http.post('/ftpUser/get.do', params)
  },
  // SNMP报警屏蔽列表
  getShieldList (params) {
    return Http.post('/snmpShieldAlarm/list.do', params)
  },
  // 添加报警屏蔽
  addSnmpShieldAlarm (params) {
    return Http.post('/snmpShieldAlarm/addSnmpShieldAlarm.do', params)
  },
  // 编辑报警屏蔽
  updateSnmpShieldAlarm (params) {
    return Http.post('/snmpShieldAlarm/updateSnmpShieldAlarm.do', params)
  },
  getSnmpShieldAlarm (params) {
    return Http.post('/snmpShieldAlarm/getSnmpShieldAlarm', params)
  },
  // 添加配置项
  addSnmpTransConfig (params) {
    return Http.post('/snmp/addSnmpTransConfig.do', params)
  },
  // 删除报警屏蔽
  deleteSnmpShieldAlarm (params) {
    return Http.post('/snmp/deleteSnmpShieldAlarm.do', params)
  },
  getSnmp (params) {
    return Http.post('/snmp/getSnmp.do', params)
  },
  updateSnmpTransConfig (params) {
    return Http.post('/snmp/updateSnmpTransConfig.do', params)
  },
  // 删除转发服务器配置
  deleteSnmpTransConfig (params) {
    return Http.post('/snmp/deleteSnmpTransConfig.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/server.js